/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Bell } from '@jda/lui-common-icon-library-mui5';

import { useStyles } from './styles';

interface InfoMessageProps {
  message: string;
  subText?: string;
  icon?: React.ReactNode;
};

const InfoMessage: React.FC<InfoMessageProps> = ({ message, icon, subText }) => {
  const classes = useStyles();
  return (
    <Grid className={classes.root}>
      <Box className={classes.iconWrap}>
        {icon ? icon : <Bell />}
      </Box>
      <Box flexDirection={'row'}>
        <Box>{message}</Box>
        {subText &&
          <Box className={classes.subTextWrap}>
            <Typography variant="body1" className={classes.subText}>{subText}</Typography>
          </Box>
        }
      </Box>
    </Grid>
  );
};

export default InfoMessage;